module.exports = __webpack_public_path__ + "img/formats.69fb5d6b.jpg";